/*
  munchief-combo-promo — the combo card's quantity stepper.

  Imported page-wise by sections/munchief-combo-promo.liquid (defer). It
  binds every .combo-promo on the page, guards with a data-comboPromoReady
  flag, and re-inits on shopify:section:load for the theme editor.

  Deliberately its own file with its own data-combo-qty-* attributes rather
  than reusing munchief-product-main.js: both sections render an
  identically-shaped .qty-stepper on the same PDP, so shared attributes
  would let one script drive the other section's counter.

  The visible counter is a <span> (the design's own control), so the value
  is mirrored into the form's hidden quantity input on every change.
*/
(function () {
  function initSection(section) {
    if (section.dataset.comboPromoReady === 'true') return;
    section.dataset.comboPromoReady = 'true';

    var value = section.querySelector('[data-combo-qty-value]');
    var input = section.querySelector('[data-combo-qty-input]');
    var down = section.querySelector('[data-combo-qty-decrease]');
    var up = section.querySelector('[data-combo-qty-increase]');
    if (!value || !down || !up) return;

    function set(next) {
      value.textContent = next;
      if (input) input.value = next;
    }

    down.addEventListener('click', function () {
      set(Math.max(1, parseInt(value.textContent, 10) - 1));
    });
    up.addEventListener('click', function () {
      set(parseInt(value.textContent, 10) + 1);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.combo-promo').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-bind when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
